import { render, staticRenderFns } from "./goodsForm.vue?vue&type=template&id=58b13c32&"
import script from "./goodsForm.vue?vue&type=script&lang=js&"
export * from "./goodsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b13c32')) {
      api.createRecord('58b13c32', component.options)
    } else {
      api.reload('58b13c32', component.options)
    }
    module.hot.accept("./goodsForm.vue?vue&type=template&id=58b13c32&", function () {
      api.rerender('58b13c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Order/goodsForm.vue"
export default component.exports